import { FilterOperator, SystemEntity } from '@wdx/clmi/clmi-swagger-gen';
import { FilterFieldName } from '../models/dynamic-tab.model';

export const CLIENT_MEMBERS_LIST = {
    lookupType: SystemEntity.PartyRole,
    field: FilterFieldName.Members,
    operator: FilterOperator.Equals,
};
